<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Groupe de Sécurité</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Nom :</label>
        </div>
        <div class="col-4">
          {{ nom }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Confidentialité :</label>
        </div>
        <div class="col-4">
          {{ confidentialiteAfficher }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Autorité :</label>
        </div>
        <div class="col-4">
          {{ autoriteAfficher }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Abréviation :</label>
        </div>
        <div class="col-4">
          {{ abreviation }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Description :</label>
        </div>
        <div class="col-4">
          {{ description }}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <Accordion>
      <AccordionTab header="Rôles">
        <div v-if="listeRoles.length > 0" class="row">
          <div class="col">
            <DataTable
                class="p-datatable-sm"
                :value="listeRoles"
                :resizableColumns="true"
                columnResizeMode="fit"
                :reorderableColumns="true"
                selectionMode="single"
                dataKey="cle"
                :paginator="false"
              >
                <Column
                    field="role"
                    :sortable="true"
                ></Column>
            </DataTable>
          </div>
        </div>
        <div v-else class="row">
          &nbsp;&nbsp;&nbsp;Aucun rôle de sécurité retourné
        </div>
      </AccordionTab>
    </Accordion>
  </div>
  <div class="row">
    <Accordion>
      <AccordionTab header="Intervenants">
        <div v-if="listeIntervenants.length > 0" class="row">
          <div class="col">
            <DataTable
                class="p-datatable-sm"
                :value="listeIntervenants"
                :resizableColumns="true"
                columnResizeMode="fit"
                :reorderableColumns="true"
                selectionMode="single"
                dataKey="codeProfilUtilisateur"
                :paginator="false"
              >
              <Column
                  field="siteOrigine"
                  header="Site origine"
                  :sortable="true"
              ></Column>
              <Column
                  field="codeProfilUtilisateur"
                  header="Code du profil"
                  :sortable="true"
              ></Column>
              <Column
                  field="compteParent"
                  header="Int."
                  dataType="boolean"
                  :sortable="true"
              >
                <template #body="{ data }">
                  <i class="pi" :class="{ 'pi-check-circle': data.compteParent }"></i>
                </template>
              </Column>
              <Column
                  field="nomIntervenant"
                  header="Nom"
                  :sortable="true"
              ></Column>
              <Column
                  field="prenomIntervenant"
                  header="Prenom"
                  :sortable="true"
              ></Column>
              <Column
                  field="nomGroupeSecurite"
                  header="Groupe de sécurité"
                  :sortable="true"
              ></Column>
              <Column
                  field="confidentialite"
                  header="Confidentialité"
                  :sortable="true"
              ></Column>
              <Column
                  field="autorite"
                  header="Autorité"
                  :sortable="true"
              ></Column>
              <Column
                  field="statut"
                  header="Statut"
                  :sortable="true"
              ></Column>
              <Column
                  field="commentaire"
                  header="Commentaire"
                  :sortable="true"
              ></Column>
            </DataTable>
          </div>
        </div>
        <div v-else class="row">
          &nbsp;&nbsp;&nbsp;Aucun rôle de sécurité retourné
        </div>
      </AccordionTab>
    </Accordion>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Consulter un groupe de sécurité");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.assignerListe();
    this.$store.dispatch('pilotage/obtenirGroupeSecuriteCleRoleAction', this.cleGrSecu)
          .then((res) => {
            this.listeRoles = res.data.sort((a, b) => {
              return this.$commun.compareString(a.role, b.role)
            });
          });
    this.$store.dispatch('pilotage/rechercherIntervenantsAction', this.criteresRechercheIntervenant)
          .then((res) => {
            this.listeIntervenants = res.data;
          });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      groupesSecurite: "pilotage/groupesSecurite",
    }),
  },
  data() {
    return {
      cleGrSecu: this.$route.params.cle,
      nom: null,
      confidentialiteAfficher: null,
      autoriteAfficher: null,
      abreviation: null,
      description: null,
      listeRoles: [],
      criteresRechercheIntervenant: {},
      listeIntervenants: [],
    }
  },
  methods: {
    trouverCle(groupeSecurite) {
      return groupeSecurite.cle == this.cleGrSecu;
    },
    assignerListe() {
      let obj = this.groupesSecurite.find(this.trouverCle);
      this.nom = obj.nom;
      this.confidentialiteAfficher = obj.confidentialiteAfficher;
      this.autoriteAfficher = obj.autoriteAfficher;
      this.abreviation = obj.abreviation;
      this.description = obj.description;
      this.criteresRechercheIntervenant.groupeSecurite = this.cleGrSecu;
    },
    fermer(){
        this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
